import React, { useEffect, useState, useMemo } from "react";
import Select from "react-select";
import axios from '../apiClient';
import Alert from '../alert';

const Winners = () => {
  const [loading, setLoading] = useState(false);
  const [winner, setWinner] = useState([]);
  const [data, setData] = useState([]);
  const [users, setUsers] = useState("");
  const [winNum, setWinNum] = useState(null);
  const [termName, setTermName] = useState("");
  const [termOptions, setTermOptions] = useState([]);
  const [prizes, setPrizes] = useState([]);
  const [prizeSelect, setPrizeSelect] = useState("");
  const [termId, setTermId] = useState("");
  const [is2D, setIs2D] = useState(true);
  const [unitPrice, setUnitPrice] = useState(1);
  const [subTotal, setSubTotal] = useState(null);
  const [errorMsg, setErrorMsg] = useState({});
  const [openAlert, setOpenAlert] = useState(false);

  useEffect(() => {
    if (prizeSelect != "") {
      const d = data.filter(
        (item) => item.prize2D == prizeSelect || item.prize3D == prizeSelect
      );
      setWinner(d);
    } else {
      setWinner(data);
    }
  }, [prizeSelect]);

  useEffect(() => {
    fetchTerms()
  }, []);

  async function fetchTerms() {
    try {
      let data = await axios.get(`/bet/getTerms?current=1&limit=1000`);
      if (data.code == 200 && data?.data && data.data?.by) {
        const termOptions = data.data?.by.map((term) => ({
          value: term.termId,
          label: `${term.termName}${term.winNum != '' && term.winNum != null ? ` (${term.winNum})` : ''}`,
          winNum: term.winNum,
          is2D: term.is2D,
          unitPrice: term.unitPrice
        }));
        setTermOptions(termOptions);
      } else {
        setErrorMsg({ code: data.code || 'ERROR', msg: data.message || 'Failed to fetch terms' });
        setOpenAlert(true);
      }
    } catch (error) {
      console.error('Error fetching terms:', error);
      setErrorMsg({ code: 'ERROR', msg: 'Network error while fetching terms' });
      setOpenAlert(true);
    }
  }

  const generateTNumbers = (var_num) => {
    let bot = (parseInt(var_num) - 1).toString();
    let top = (parseInt(var_num) + 1).toString();
    if (var_num === "000") {
      bot = "999";
      top = "001";
    } else if (var_num === "999") {
      bot = "998";
      top = "000";
    } else if (var_num.charAt(0) === "0" && var_num.charAt(1) === "0") {
      // leading 00 e.g., 002
      bot = "00" + (parseInt(var_num) - 1).toString();
      top =
        (parseInt(var_num) + 1).toString().length === 2
          ? "0" + (parseInt(var_num) + 1).toString()
          : "00" + (parseInt(var_num) + 1).toString();
    } else if (var_num.charAt(0) === "0") {
      //leading 0 e.g., 019
      bot = "0" + (parseInt(var_num) - 1).toString();
      top = "0" + (parseInt(var_num) + 1).toString();
    }
    var arr = Array.from(var_num);
    let t = [];
    if (arr[0] == arr[1] && arr[1] == arr[2] && arr[0] == arr[2]) {
      t.push({
        num: var_num,
        same: true,
      });
    } else if (arr[0] == arr[1] || arr[0] == arr[2] || arr[1] == arr[2]) {
      for (let i = 0; i < 3; i++) {
        if (i == 0) {
          t.push({
            num: arr[0] + arr[1] + arr[2],
            same: true,
          });
        } else if (i == 1) {
          if (arr[0] == arr[1]) {
            t.push({
              num: arr[0] + arr[2] + arr[1],
              same: false,
            });
          } else if (arr[1] == arr[2]) {
            t.push({
              num: arr[1] + arr[0] + arr[2],
              same: false,
            });
          } else {
            t.push({
              num: arr[0] + arr[2] + arr[1],
              same: false,
            });
          }
        } else {
          if (arr[0] == arr[1]) {
            t.push({ num: arr[2] + arr[0] + arr[1], same: false });
          } else if (arr[1] == arr[2]) {
            t.push({ num: arr[1] + arr[2] + arr[0], same: false });
          } else {
            t.push({ num: arr[1] + arr[2] + arr[0], same: false });
          }
        }
      }
    } else {
      for (let i = 0; i < 6; i++) {
        if (i == 0) {
          t.push({ num: arr[0] + arr[1] + arr[2], same: true });
        } else if (i == 1) {
          t.push({ num: arr[0] + arr[2] + arr[1], same: false });
        } else if (i == 2) {
          t.push({ num: arr[1] + arr[0] + arr[2], same: false });
        } else if (i == 3) {
          t.push({ num: arr[1] + arr[2] + arr[0], same: false });
        } else if (i == 4) {
          t.push({ num: arr[2] + arr[0] + arr[1], same: false });
        } else {
          t.push({ num: arr[2] + arr[1] + arr[0], same: false });
        }
      }
    }
    t.push(
      {
        num: bot,
        same: false,
      },
      {
        num: top,
        same: false,
      }
    );
    let tNumbers = t.filter((tNum) => tNum.same == false);
    const result = tNumbers.map((item) => item.num);
    return result;
  };

  useEffect(() => {
    const fetchWinners = async () => {
      try {
        setLoading(true);
        const uid = ``;
        const tNumbers = is2D == 1 ? "" : generateTNumbers(winNum).join(",");
        const response = await axios.get(
          `/bet/getWinnerReportEasi?termId=${termId}&winNum=${winNum}&tNum=${tNumbers}${uid}`);
        console.log('resp', response)
        if (response.code === "200") {
          const winResults = response.data.winNum;
          console.log("winResults ==>> ", winResults);
          const merged = {};

          winResults.forEach((item) => {
            const key = `${item.slipId}-${item.userId}`;
            if (!merged[key]) {
              merged[key] = { ...item }; // clone original
            } else {
              merged[key].amount += item.amount;
            }
          });

          const winMergedResults = Object.values(merged);

          const tResults = response.data.tNum;

          const merged1 = {};

          tResults.forEach((item) => {
            const key = `${item.slipId}-${item.userId}`;
            if (!merged1[key]) {
              merged1[key] = { ...item }; // clone original
            } else {
              merged1[key].amount += item.amount;
            }
          });

          const tMergedResults = Object.values(merged1);

          const winMap = {};
          winMergedResults.forEach((item) => {
            const key = `${item.userId}|${item.slipId}`;
            if (!winMap[key]) winMap[key] = { ...item };
            else winMap[key].amount += item.amount;
          });

          // Step 2: Group Tarry by slipId and sum amount
          const tMap = {};
          tMergedResults.forEach((item) => {
            const key = `${item.userId}|${item.slipId}`;
            if (!tMap[key]) tMap[key] = { ...item };
            else tMap[key].amount += item.amount;
          });

          // Step 3: Merge both
          const slipIds = new Set([
            ...Object.keys(winMap),
            ...Object.keys(tMap),
          ]);
          const result = [];

          slipIds.forEach((slipId) => {
            const win = winMap[slipId];
            const t = tMap[slipId];

            const TotalAmountWithPrize = win?.amount || 0;
            const TotalTAmountWithPrize = t?.amount || 0;

            const base = win || t;
            console.log("base ==>> ", Number(base.unitPrice));
            result.push({
              ...base,
              amount:
                is2D == 1
                  ? Number(TotalAmountWithPrize * base.prize2D * unitPrice)
                  : Number(TotalAmountWithPrize * base.prize3D * unitPrice) +
                  Number(TotalTAmountWithPrize * base.tPrize * unitPrice),
              TotalAmountWithPrize,
              TotalTAmountWithPrize,
              winT: `${TotalAmountWithPrize}(${TotalTAmountWithPrize})`,
            });
          });

          const slips = result.sort(
            (a, b) => Number(a.slipId) - Number(b.slipId)
          );
          setPrizes(
            is2D == 1
              ? [...new Set(slips.map((s) => s.prize2D))]
              : [...new Set(slips.map((s) => s.prize3D))]
          );
          setWinner(slips);
          setData(slips);
        } else {
          setWinner([]);
          setData([]);
        }
      } catch (error) {
        setLoading(false);
      } finally {
        setLoading(false);
      }
    };
    if (termId) {
      fetchWinners();
    }
  }, [termId]);

  // Calculate totals
  useEffect(() => {
    if (winner.length > 0) {
      const totals = winner.reduce(
        (acc, row) => {
          acc.amount += parseFloat(row.amount || "0");
          acc.TotalAmountWithPrize += parseFloat(
            row.TotalAmountWithPrize || "0"
          );
          acc.TotalTAmountWithPrize += parseFloat(
            row.TotalTAmountWithPrize || "0"
          );
          return acc;
        },
        {
          amount: 0,
          TotalAmountWithPrize: 0,
          TotalTAmountWithPrize: 0,
        }
      );
      setSubTotal(totals);

      console.log("totals ", totals);
    }
  }, [winner]);

  const handleTermNameChange = (selectedOption) => {
    setWinNum(selectedOption.winNum);
    setTermId(selectedOption.value);
    setTermName(selectedOption.label);
    setIs2D(selectedOption.is2D);
    setUnitPrice(selectedOption.unitPrice);
    setPrizeSelect("");
  };

  const handleCloseAlert = () => setOpenAlert(false)

  const formatter = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  return (
    <div style={{ padding: '20px', backgroundColor: '#f5f5f5', minHeight: '100vh' }}>
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column', 
        gap: '20px'
      }}>
        <Select
          style={{ 
            width: '100%',
            maxWidth: '300px'
          }}
          onChange={handleTermNameChange}
          showSearch
          placeholder="Select Term"
          options={termOptions}
        />
      </div>

      <div style={{ 
        marginTop: '20px',
        padding: '15px',
        backgroundColor: 'white',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          marginBottom: '15px'
        }}>
          <h3 style={{ margin: 0, color: '#333' }}>{`ပေါက်သီး --> ${winNum}`}</h3>
          <div style={{ 
            display: 'flex', 
            gap: '20px', 
            fontSize: '14px',
            color: '#666'
          }}>
            <span>ဒဲ့: {formatter.format(subTotal?.TotalAmountWithPrize || 0)}</span>
            <span>တွတ်: {formatter.format(subTotal?.TotalTAmountWithPrize || 0)}</span>
          </div>
        </div>

        {loading ? (
          <div style={{ 
            display: 'flex', 
            flexDirection: 'column',
            alignItems: 'center', 
            justifyContent: 'center',
            padding: '40px',
            backgroundColor: '#f9f9f9',
            borderRadius: '8px',
            border: '1px solid #e0e0e0'
          }}>
            <div style={{
              width: '40px',
              height: '40px',
              border: '4px solid #f3f3f3',
              borderTop: '4px solid #5e35b1',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite',
              marginBottom: '15px'
            }}></div>
            <p style={{ 
              margin: 0, 
              color: '#666',
              fontSize: '16px'
            }}>ဒေတာများ ရယူနေသည်...</p>
          </div>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ 
              width: '100%', 
              borderCollapse: 'collapse',
              backgroundColor: 'white',
              borderRadius: '8px',
              overflow: 'hidden',
              boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
            }}>
              <thead>
                <tr style={{ backgroundColor: '#f8f9fa' }}>
                  <th style={{ 
                    padding: '12px 15px', 
                    textAlign: 'left',
                    borderBottom: '2px solid #dee2e6',
                    fontWeight: '600',
                    color: '#495057'
                  }}>Slip ID</th>
                  <th style={{ 
                    padding: '12px 15px', 
                    textAlign: 'left',
                    borderBottom: '2px solid #dee2e6',
                    fontWeight: '600',
                    color: '#495057'
                  }}>Customer</th>
                  <th style={{ 
                    padding: '12px 15px', 
                    textAlign: 'right',
                    borderBottom: '2px solid #dee2e6',
                    fontWeight: '600',
                    color: '#495057'
                  }}>Amount</th>
                  <th style={{ 
                    padding: '12px 15px', 
                    textAlign: 'right',
                    borderBottom: '2px solid #dee2e6',
                    fontWeight: '600',
                    color: '#495057'
                  }}>Total Amount with Prize</th>
                </tr>
              </thead>
              <tbody>
                {winner && winner.length > 0 ? (
                  winner.map((row, index) => (
                    <tr key={`winner-${index}`} style={{ 
                      borderBottom: '1px solid #dee2e6',
                      '&:hover': { backgroundColor: '#f8f9fa' }
                    }}>
                      <td style={{ 
                        padding: '10px 15px',
                        borderBottom: '1px solid #dee2e6'
                      }}>{row.slipId}</td>
                      <td style={{ 
                        padding: '10px 15px',
                        borderBottom: '1px solid #dee2e6'
                      }}>{row.customerName}</td>
                      <td style={{ 
                        padding: '10px 15px', 
                        textAlign: 'right',
                        borderBottom: '1px solid #dee2e6'
                      }}>{formatter.format(row.amount)}</td>
                      <td style={{ 
                        padding: '10px 15px', 
                        textAlign: 'right',
                        borderBottom: '1px solid #dee2e6',
                        color: '#dc3545',
                        fontWeight: 'bold'
                      }}>{row.winT}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td 
                      colSpan="4" 
                      style={{ 
                        padding: '20px', 
                        textAlign: 'center',
                        color: '#6c757d',
                        fontStyle: 'italic'
                      }}
                    >
                      No data available
                    </td>
                  </tr>
                )}
                {winner && winner.length > 0 && (
                  <tr style={{ 
                    backgroundColor: '#e9ecef',
                    fontWeight: 'bold'
                  }}>
                    <td style={{ 
                      padding: '12px 15px',
                      borderTop: '2px solid #adb5bd'
                    }}>Total</td>
                    <td style={{ 
                      padding: '12px 15px',
                      borderTop: '2px solid #adb5bd'
                    }}></td>
                    <td style={{ 
                      padding: '12px 15px', 
                      textAlign: 'right',
                      borderTop: '2px solid #adb5bd',
                      color: '#495057'
                    }}>
                      {formatter.format(subTotal?.amount || 0)}
                    </td>
                    <td style={{ 
                      padding: '12px 15px', 
                      textAlign: 'right',
                      borderTop: '2px solid #adb5bd',
                      color: '#dc3545',
                      fontWeight: 'bold'
                    }}>
                      {formatter.format((subTotal?.TotalAmountWithPrize || 0) + (subTotal?.TotalTAmountWithPrize || 0))}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {openAlert && (
        <Alert
          message={errorMsg.msg}
          type="error"
          onClose={handleCloseAlert}
        />
      )}
    </div>
  );
};

export default Winners;
